import gql from "graphql-tag"
const ADD_ORDER = gql`
    mutation addOrder($tableID: String!, $menuItemIDs: [ItemToOrder]!, $note: String, $uniqueUserID: ID!) {
        addOrder(tableID: $tableID, menuItemIDs: $menuItemIDs, note: $note, uniqueUserID: $uniqueUserID)
    }
`;
export {
    ADD_ORDER
}